/**
 * 状态码。数值与 status.ikuncode.cc 的 /api/status 保持一致，
 * 这样前端组件和第三方消费者可以直接复用。
 *
 * 注意 UNAVAILABLE 是 0 而不是最大值 —— 这点反直觉，
 * 所以不要用数值大小来比较严重程度，用 SEVERITY_ORDER。
 */
export const Status = {
    UNAVAILABLE: 0,
    AVAILABLE: 1,
    DEGRADED: 2,
};
/** 严重程度排序，数字越大越严重。用于聚合时取「最差」状态。 */
export const SEVERITY_ORDER = {
    [Status.AVAILABLE]: 0,
    [Status.DEGRADED]: 1,
    [Status.UNAVAILABLE]: 2,
};
/**
 * 失败原因分类。一次探测只会命中其中一个，
 * 聚合后用于在 UI 上区分「网关挂了」和「模型被限流」。
 */
export const FailureKind = {
    NONE: 'none',
    SLOW_LATENCY: 'slow_latency',
    RATE_LIMIT: 'rate_limit',
    SERVER_ERROR: 'server_error',
    CLIENT_ERROR: 'client_error',
    AUTH_ERROR: 'auth_error',
    INVALID_REQUEST: 'invalid_request',
    NETWORK_ERROR: 'network_error',
    RESPONSE_TIMEOUT: 'response_timeout',
    CONTENT_MISMATCH: 'content_mismatch',
};
//# sourceMappingURL=types.js.map